<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="BLURB ParaOverride-1">“Mouw offers advice that is not only informative but also encouraging to evangelical scholars and those considering a scholarly vocation. Herein are sage virtues needed for the evangelical scholarly pursuit.” </p>
<p class="BLURBER">— Amos Yong</p>
<p class="BLURBERPLACE ParaOverride-2">Fuller Seminary</p>
<p class="BLURB">“A refreshing reminder that cultivating our thought life and scholarship can only be done when we also keep in touch with the Lord. These musings from an experienced Christian leader will be solid food for Christian scholars everywhere.”</p>
<p class="BLURBER">— Darrell Bock</p>
<p class="BLURBERPLACE">Dallas Theological Seminary</p>
<p class="BLURB">“Mouw assures us that we can navigate the perilous terrain of the hyper-critical, the fragmentation of knowledge, the isolation, all the while attending to the One in whom all reality coheres. I can hear him saying, ‘You can do this.’ ”</p>
<p class="BLURBER">— Cheryl Bridges Johns</p>
<p class="BLURBERPLACE">Princeton Theological Seminary</p>
<p class="BLURB">“Winsome guidance. . . . Every evangelical scholar will benefit from reading these essays based on a life of leadership in the evangelical academy.”</p>
<p class="BLURBER ParaOverride-3">— Roger E. Olson</p>
<p class="BLURBERPLACE">Truett Seminary, Baylor University</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mouw_Called_to_the_Life_of_the_Mind_text_CC.vue?63bac7f3